module.exports = __webpack_public_path__ + "img/NoEncontrada.bac12951.png";